// Applies dir/lang to <html> and runs the DOM auto-translator.
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { languages } from "@/i18n";
import { useAutoTranslate } from "@/hooks/useAutoTranslate";

const LanguageManager = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const apply = (code: string) => {
      const lang = languages.find((l) => l.code === code) || languages[0];
      document.documentElement.dir = lang.dir;
      document.documentElement.lang = lang.code;
    };
    apply(i18n.language);
    i18n.on("languageChanged", apply);
    return () => { i18n.off("languageChanged", apply); };
  }, [i18n]);

  useAutoTranslate();
  return null;
};

export default LanguageManager;
